var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalFreeStrikersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 12.6654C13.0639 12.6654 15.5418 10.1874 15.5418 7.1237C15.5418 4.05995 13.0639 1.58203 10.0002 1.58203C6.93641 1.58203 4.4585 4.05995 4.4585 7.1237C4.4585 10.1874 6.93641 12.6654 10.0002 12.6654ZM10.0002 3.16536C12.1852 3.16536 13.9585 4.9387 13.9585 7.1237C13.9585 9.3087 12.1852 11.082 10.0002 11.082C7.81516 11.082 6.04183 9.3087 6.04183 7.1237C6.04183 4.9387 7.81516 3.16536 10.0002 3.16536Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41667 7.1263C8.85389 7.1263 9.20833 6.77186 9.20833 6.33464C9.20833 5.89741 8.85389 5.54297 8.41667 5.54297C7.97944 5.54297 7.625 5.89741 7.625 6.33464C7.625 6.77186 7.97944 7.1263 8.41667 7.1263Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5832 7.1263C12.0204 7.1263 12.3748 6.77186 12.3748 6.33464C12.3748 5.89741 12.0204 5.54297 11.5832 5.54297C11.1459 5.54297 10.7915 5.89741 10.7915 6.33464C10.7915 6.77186 11.1459 7.1263 11.5832 7.1263Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 5.54036C10.4374 5.54036 10.7918 5.18592 10.7918 4.7487C10.7918 4.31147 10.4374 3.95703 10.0002 3.95703C9.56294 3.95703 9.2085 4.31147 9.2085 4.7487C9.2085 5.18592 9.56294 5.54036 10.0002 5.54036Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0415 15.0404H7.62484C8.49567 15.0404 9.20817 15.7529 9.20817 16.6237V17.4154H10.7915V16.6237C10.7915 15.7529 11.504 15.0404 12.3748 15.0404H13.9582V13.457H6.0415V15.0404Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalFreeStrikersIcon);
export default __webpack_public_path__ + "static/media/totalFreeStrikersIcon.a578f624c2565da9023cb74554426075.svg";
export { ForwardRef as ReactComponent };